
import React from 'react';
import {
  Column,
  SimpleTable
} from '../../../../components/SimpleTable';
import {SupportTicketRelatedTaskModel} from '../../../../model/support/support-ticket-related-task.model';

export type Props = {
  relatedTasks: SupportTicketRelatedTaskModel[]
  translate: (key: string) => string
}

export const SupportTicketRelatedTasksDrawerTable = ({relatedTasks, translate}: Props) => {
  const columns: Column<SupportTicketRelatedTaskModel>[] = [
    { key: 'title', label: 'Nazwa zadania', render: (row) => row.title },
    { key: 'taskType', label: 'Typ zadania', render: (row) => translate(`support.plan.task.type.${row.taskType}`) },
    { key: 'date', label: 'Planowana data', render: (row) => `${row.startDate} - ${row.endDate}` },
    { key: 'time', label: 'Planowany czas ', render: (row) => `${row.startTime} - ${row.endTime}` },
  ]

  return <SimpleTable
    rows={relatedTasks}
    columns={columns}
    rowKey={(row) => row.id}
  />
}